/* eslint-disable no-param-reassign */
var metadataKeyToName = function metadataKeyToName(key) {
  return key.replaceAll('_', ' ');
};
var metadataNameToKey = function metadataNameToKey(name) {
  return "".concat(name.trim().replaceAll(' ', '_'));
};
var reservedMetadataNames = ['Technology', 'Kit Type'];
export { metadataKeyToName, metadataNameToKey, reservedMetadataNames };